var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert-warning"},[_c('h4',{staticClass:"alert-heading border border-dark border-top-0 border-left-0 border-right-0"},[_vm._v(" Access denied ")]),_c('p',[_vm._v(" This requires Roles to be assigned to your user within personnel security, application tab. Please contact your systems administrator. ")])])
}]

export { render, staticRenderFns }